const Occurrences = () => import('@/modules/occurrences');

export default [
  {
    path: '/ocorrencias',
    name: 'occurrences-list',
    component: Occurrences,
    meta: {
      isAvaliableInMenu: true,
      navbarTitle: 'Ajustes em Faturas',
      menuData: {
        title: 'Ajustes em Faturas',
        id: 'occurencesSidebar',
        section: 'Financeiro',
        icon: 'bill',
      },
    },
  },
];
